import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { OrderListItem } from 'reg-hub-common';
import { OrderListRepositoryService } from '../../services/order-list/order-list-repository.service';

@Component({
    selector: 'app-complete-order-list',
    templateUrl: './complete-order-list.component.html',
    styleUrls: ['./complete-order-list.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompleteOrderListComponent {
  @Input() data: OrderListItem[] = [];
  @Input() total: number = 0;
  @Input() loading: boolean = false;

  protected displayedColumns = [
    'referenceNumber',
    'orderTypeID',
    'jurisdiction',
    'description',
    'orderStatusTypeID',
    'messages'
  ]

  constructor(
    protected repo: OrderListRepositoryService,
    protected router: Router) { }

  protected onViewAll() {
    let params = {
      status: 'Complete',
      sortColumn: 'orderStatusUpdatedDate',
      sortDirection: 'desc'
    }

    this.router.navigate(['/orders'], { queryParams: params })
  }
}
